import { Chips, SelectGeneric } from 'ypf-pas-general-ui-components';
import PropTypes from 'prop-types';

import { postOperationsReceivers, postReceivers } from '../../services/yclickMaster';
import './CommunicateForm.scss';

const CommunicateForm = ({
  communicateToForm,
  defaultReceivers,
  selectProps,
  inspectors,
  isOyM
}) => {
  const { errors, businessUnitId, isDisabled, isInvalid, onChange, value } = selectProps;
  const isDetailsPage = window.location.pathname.includes('detail');

  const fetchAditionalReceivers = async (val) => {
    if (val.length < 3) return null;
    const response = isOyM
      ? await postOperationsReceivers([businessUnitId], val)
      : await postReceivers([businessUnitId], val);

    return response;
  };

  return (
    <>
      {isDetailsPage && (
        <div className="d-flex align-items-center mb-2">
          <h6 className="me-4 mb-0">Inspector:</h6>
          <Chips data={inspectors || []} variant="info" />
        </div>
      )}
      <div className="d-flex align-items-center">
        <h6 className="me-3 mb-0">Comunicar a:</h6>
        <Chips data={defaultReceivers || []} variant="info" />
      </div>
      {communicateToForm && <hr />}
      <div
        className={[
          'mt-3',
          communicateToForm ? 'communicate-to' : '',
          communicateToForm && isDisabled ? 'read-only' : ''
        ]
          .filter(Boolean)
          .join(' ')}
      >
        <SelectGeneric
          async
          errors={errors}
          fetchData={fetchAditionalReceivers}
          isDisabled={isDisabled}
          isInvalid={isInvalid}
          isMulti
          label="Con copia a:"
          name="associatedUsers.aditionalReceivers"
          onChange={onChange}
          placeholder="Buscar por nombre o grupo"
          value={value}
          variantOptions="info"
          withSelect="100%"
        />
      </div>
    </>
  );
};

CommunicateForm.propTypes = {
  communicateToForm: PropTypes.bool,
  defaultReceivers: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string
    })
  ).isRequired,
  selectProps: PropTypes.shape({
    errors: PropTypes.string.isRequired,
    businessUnitId: PropTypes.number.isRequired,
    isDisabled: PropTypes.bool,
    isInvalid: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.arrayOf(PropTypes.string).isRequired
  }).isRequired,
  inspectors: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string
    })
  ),
  isOyM: PropTypes.bool.isRequired
};

CommunicateForm.defaultProps = {
  communicateToForm: false,
  inspectors: []
};
export default CommunicateForm;
